module.exports = __webpack_public_path__ + "static/media/logo2.03266ae3.png";